<template>
    <div class="stones-container">
        <!-- v-tooltip se na dotyku nezobrazi (Z2 v roadmap-mobile.md) - trvaly popisek nahore misto -->
        <span class="stones-hint">{{ $t('trainer.stones.hint') }}</span>
        <div class="stones-rank-legend" @click="showRankLegend = true">
            <span class="stones-rank-legend__label">{{ $t('trainer.stones.rankLegendWeakest') }}</span>
            <img
                v-for="(src, idx) in rankLegendIcons"
                :key="idx"
                :src="src"
                class="stones-rank-legend__icon"
                alt=""
            />
            <span class="stones-rank-legend__label">{{ $t('trainer.stones.rankLegendStrongest') }}</span>
        </div>

        <ResponsiveDialog
            v-if="showRankLegend"
            v-model="showRankLegend"
            :max-width="360"
            :full-height="false"
            :header-title="$t('trainer.stones.rankLegendTitle')"
            header-class="skin-window-header--oak"
            card-class="skin-card"
        >
            <div class="skin-window--oak stones-dialog-bg">
                <v-card-text class="transparent03 stones-dialog-content">
                    <StonePowerRankLegend/>
                </v-card-text>
            </div>
        </ResponsiveDialog>
        <div class="stones-grid">
            <div
                v-for="item in stones"
                :key="item.id"
                class="stones-grid__item"
                @click="showDialog(item)"
            >
                <v-img
                    class="stone-img"
                    :src="require(`@/assets/pic${item.picture}`)"
                    contain
                />
                <v-icon
                    v-if="item.lockedInTradeOffer"
                    color="#FFD700"
                    size="20"
                    class="stones-grid__lock-icon"
                >mdi-scale-balance</v-icon>
                <img
                    v-if="rankIconSrc(item)"
                    :src="rankIconSrc(item)"
                    class="stones-grid__rank-icon"
                    alt=""
                />
            </div>
        </div>

        <ResponsiveDialog
            v-if="stone"
            v-model="show"
            :max-width="620"
            :full-height="false"
            :header-title="stone.name"
            header-class="skin-window-header--oak"
            card-class="skin-card"
        >
            <div class="skin-window--oak stones-dialog-bg">
                <v-card-text class="transparent03 justify-center text-center stones-dialog-content">
                    <v-card-title v-if="posiblePokemonsLength > 0">{{ $t('trainer.stones.trainHint', {stoneVal: stone.stoneVal, name: stone.name}) }}</v-card-title>

                    <v-col class="d-flex flex-column flex-md-row align-center">
                        <v-img
                            v-if="posiblePokemonsLength > 0"
                            :src="require(`@/assets/pic/stones/${stone.type.id}.png`)"
                            class="ma-0 pa-0 stones-dialog-stone-img"
                            contain
                        />
                        <v-carousel
                            v-if="posiblePokemonsLength > 0"
                            v-model="carouselId"
                            height="160"
                            hide-delimiters
                            tile
                        >
                            <v-carousel-item
                                v-for="pokemon in getPokemonsForStone(stone)"
                                :key="pokemon.id"
                            >
                                <v-sheet
                                    class="transparent"
                                    height="100%"
                                >
                                    <v-row
                                        class="fill-height"
                                        align="center"
                                        justify="center"
                                    >
                                        <v-img
                                            :src="require(`@/assets/pic/pokemons${pokemon.pokemonType.img}`)"
                                            height="150"
                                            class="ma-0 pa-0 fill-height"
                                            contain
                                        />
                                    </v-row>
                                </v-sheet>
                            </v-carousel-item>
                        </v-carousel>
                    </v-col>
                    <v-row class="d-flex justify-center">
                        <v-btn
                            :loading="loading"
                            v-if="posiblePokemonsLength > 0 && pokemon"
                            color="warning black--text"
                            @click="useStone()"
                        >
                            {{ $t('trainer.stones.trainButton') }} {{pokemon.name}}
                        </v-btn>
                    </v-row>

                    <v-row class="d-flex flex-column align-center" v-if="posiblePokemonsLength <= 0">
                        <v-col class="d-flex justify-center">
                            {{ $t('trainer.stones.noPokemonOfType', {type: $t('common.typeNames.' + stone.type.name)}) }}
                        </v-col>
                        <v-btn color="warning black--text" @click="goToTradeHub()">
                            {{ $t('trainer.stones.offerOnMarketButton') }}
                        </v-btn>
                    </v-row>
                </v-card-text>
            </div>
        </ResponsiveDialog>

        <!-- nevratna akce (kamen se spotrebuje) - noAutoConfirm obchazi autoConfirm prepinac v Options, tohle potvrzeni nejde vypnout -->
        <ConfirmDialog ref="confirmDialog"/>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from 'vuex';
    import {Categories, StonePowerRankOrder} from "@/utils/itemsEnum";
    import ResponsiveDialog from "@/components/utils/ResponsiveDialog";
    import ConfirmDialog from "@/components/utils/ConfirmDialog";
    import StonePowerRankLegend from "@/components/utils/StonePowerRankLegend";
    // import {API_ENTRYPOINT} from "@/config/entrypoint";

    export default {
        components: { ResponsiveDialog, ConfirmDialog, StonePowerRankLegend },
        props: {
          items: {Array, default: []},
          tempPokemons: {Array, default: []},
          size: {Number, default: 50},
          reloadPage: {Function, default: () => {}},
        },
        data() {
            return {
                types: Categories,
                pokemons: [],
                pokemon: null,
                loading: false,
                show: false,
                stone: null,
                carouselId: 0,
                stones: [],
                posiblePokemonsLength: 0,
                showRankLegend: false,
            }
        },
        computed: {
            ...mapGetters({
                user: 'user/item',
            }),
            rankLegendIcons() {
                return StonePowerRankOrder.map((_, idx) => require(`@/assets/pic/rank/rank-${idx + 1}.png`));
            },
        },
        watch:{
            carouselId() {
                this.pokemon = this.getPokemonsForStone(this.stone)[this.carouselId];
            },
            items() {
              this.stones = this.sortStones(this.items);
            },
        },
        created() {
            this.stones = this.sortStones(this.items);
        },
        methods: {
            ...mapActions({
                getPokemons: 'trainer/loadPokemons',
                useStoneToPokemon: 'trainer/useStoneToPokemon',
                getInfoMessages: 'trainer/loadInfoMessages',
            }),
            rankIconSrc(item) {
                if (!item.stoneVal) {
                    return null;
                }
                const idx = StonePowerRankOrder.indexOf(item.stoneVal);
                if (idx === -1) {
                    return null;
                }
                return require(`@/assets/pic/rank/rank-${idx + 1}.png`);
            },
            sortStones(items) {
                return [...items].sort((a, b) => {
                    const typeCompare = a.type.name.localeCompare(b.type.name);
                    if (typeCompare !== 0) {
                        return typeCompare;
                    }
                    return StonePowerRankOrder.indexOf(a.stoneVal) - StonePowerRankOrder.indexOf(b.stoneVal);
                });
            },
            showDialog(stone) {
                if (stone.lockedInTradeOffer) {
                    // Popup se vykresluje az v TrainerBag.vue (mimo Swiper) -
                    // position:fixed uvnitr transformovaneho swiper-slide se
                    // pozicuje vuci nemu, ne vuci viewportu. Posilame cely
                    // stone (potrebuje openTradeOfferId na zruseni nabidky).
                    this.$emit('locked-stone-click', stone);
                    return;
                }
                this.stone = stone;
                this.loading = true;
                this.getPokemons(this.tempPokemons).then(
                    (data) => {
                        this.pokemons = data;
                        this.loading = false;
                        this.carouselId = 0;
                        this.pokemon = this.getPokemonsForStone(this.stone)[0];
                        this.show = true;
                    }
                );
            },
            getPokemonsForStone(stone) {
                    if (stone.type.id === 'ULTIMATE') {
                    let pokemons = this.pokemons.filter(() => { return true;});
                    this.posiblePokemonsLength = pokemons.length;
                    return pokemons;
                }
                if (this.pokemons !== undefined) {
                    let pokemons = this.pokemons.filter((p) => { return p.pokemonType.type.id === stone.type.id });
                    this.posiblePokemonsLength = pokemons.length;
                    return pokemons;
                } else {
                    return [];
                }
            },
            goToTradeHub() {
                this.$router.push({name: 'TradeHub', query: {stoneId: String(this.stone.id)}});
            },
            async useStone() {
                let rlyTrain = await this.$refs.confirmDialog.open(
                    this.$t('trainer.stones.confirmUseStone', {stoneName: this.stone.name, pokemonName: this.pokemon.name}),
                    {
                        oak: true,
                        noAutoConfirm: true,
                    }
                );
                if (!rlyTrain) {
                    return;
                }
                this.loading = true;
                let obj = {pokemonId: this.pokemon.id, stoneId: this.stone.id, method: "POST"};
                this.useStoneToPokemon(obj).then(
                    () => {
                        this.getInfoMessages(this.user.id);
                        this.stones = this.stones.filter(e => e.id !== this.stone.id);
                        this.show = false;
                        this.reloadPage();
                        this.loading = false;
                    }
                );

            }
        },
    }
</script>

<style scoped>

.stones-container {
    width: 100%;
}

.stones-dialog-bg {
    display: flex;
    flex-direction: column;
    min-height: 0;
}
/* !important nutne - Vuetify ".v-dialog > .v-card > .v-card__text" ma vyssi specificitu (viz stejny nalez u PokemonManager.vue) */
.stones-dialog-content {
    padding-bottom: var(--responsive-dialog-close-clearance) !important;
}
@media (min-width: 960px) {
    .stones-dialog-content {
        padding-bottom: 16px !important;
    }
}

.stones-dialog-stone-img {
    width: 100%;
    height: 75px;
}
@media (min-width: 960px) {
    .stones-dialog-stone-img {
        height: 150px;
    }
}

.stones-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    padding: 4px;
}

.stones-grid__item {
    position: relative;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
    width: clamp(60px, 20cqi, 100px);
}
.stones-grid__lock-icon {
    /* !important nutne - Vuetify ".v-icon.v-icon" ma stejnou specificitu a nastavuje position: relative,
       poradi v cascade neni garantovane (viz stejny vzor u .circle-tile-corner-icon/.items-grid__permanent-icon) */
    position: absolute !important;
    bottom: 0;
    left: 6px;
    filter: drop-shadow(0 0 3px rgba(0,0,0,0.9)) drop-shadow(0 0 3px rgba(0,0,0,0.9));
}
.stones-grid__rank-icon {
    position: absolute;
    bottom: 0;
    right: 6px;
    width: 20px;
    height: 20px;
    filter: drop-shadow(0 0 3px rgba(255,215,0,0.9)) drop-shadow(0 0 3px rgba(255,215,0,0.9));
}
.theme--dark .stones-grid__rank-icon {
    filter: invert(1) drop-shadow(0 0 3px rgba(255,215,0,0.9)) drop-shadow(0 0 3px rgba(255,215,0,0.9));
}

.stone-img {
    width: clamp(60px, 20cqi, 100px);
    height: clamp(72px, 24cqi, 120px);
    max-width: 100%;
    max-height: 100%;
}

.stones-hint {
    display: block;
    font-size: 12px;
    line-height: 1.2;
    text-align: center;
    padding: 4px 4px 8px;
}
.theme--light .stones-hint {
    color: rgba(0, 0, 0, .7);
}
.theme--dark .stones-hint {
    color: rgba(255, 255, 255, .7);
}

.stones-rank-legend {
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 3px;
    margin: 0 4px 10px;
    padding: 6px 6px;
    border-radius: 6px;
}
.theme--light .stones-rank-legend {
    background-color: rgba(0, 0, 0, .05);
    border: 1px solid rgba(0, 0, 0, .08);
}
.theme--dark .stones-rank-legend {
    background-color: rgba(255, 255, 255, .05);
    border: 1px solid rgba(255, 255, 255, .12);
}

.stones-rank-legend__icon {
    width: 14px;
    height: 14px;
    flex: 0 0 auto;
    filter: drop-shadow(0 0 2px rgba(255,215,0,0.9));
}
.theme--dark .stones-rank-legend__icon {
    filter: invert(1) drop-shadow(0 0 2px rgba(255,215,0,0.9));
}

.stones-rank-legend__label {
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: .02em;
    white-space: nowrap;
    flex: 0 0 auto;
}
.stones-rank-legend__label:first-child {
    margin-right: 2px;
}
.stones-rank-legend__label:last-child {
    margin-left: 2px;
}
.theme--light .stones-rank-legend__label {
    color: rgba(0, 0, 0, .6);
}
.theme--dark .stones-rank-legend__label {
    color: rgba(255, 255, 255, .6);
}
</style>
